import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=95a2d95e&"
import script from "./ImgView.vue?vue&type=script&lang=js&"
export * from "./ImgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports